var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "page_title" },
      [
        _c("CustomBreadcrumb", {
          attrs: { suffix: "Order NO. " + _vm.orderId }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "shipping-invoice-action" },
      [
        _c("el-button", { on: { click: _vm.generatePDF } }, [
          _vm._v("Print Packing List")
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "shipping-invoice-border",
        attrs: { id: "shipping-invoice-pdf" }
      },
      [
        _c("div", { staticClass: "shipping-invoice-title" }, [
          _vm._v("Print packing slip")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "shipping-invocie-header" }, [
          _c("div", { staticClass: "shipping-invoice-header-address" }),
          _vm._v(" "),
          _c("div", { staticClass: "shipping-invoice-header-order" }, [
            _c("div", { staticClass: "shipping-invoice-header-order-title" }, [
              _vm._v("Order #" + _vm._s(_vm.orderId))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "shipping-invoice-header-order-content" },
              [
                _c(
                  "div",
                  { staticClass: "shipping-invoice-header-address-row" },
                  [_c("span", [_vm._v(_vm._s(_vm.orderDate))])]
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", {
          staticStyle: {
            height: "2px",
            "background-color": "#5E5E5E",
            display: "block",
            width: "100%",
            "margin-top": "20px"
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "order_item_list" },
          [
            _c("div", { staticClass: "order_item_title" }, [_vm._v("Items")]),
            _vm._v(" "),
            _vm._l(_vm.skuList, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "order_item" },
                [
                  _c("div", { staticClass: "order_item_box" }, [
                    _c("div", { staticClass: "order_item_img" }, [
                      _c("img", { attrs: { src: item.skuImg } })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "order_item_right" }, [
                      _c("div", { staticClass: "order_item_title" }, [
                        _vm._v(_vm._s(item.skuName))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order_item_variant" }, [
                        _vm._v(_vm._s(item.finalSkuName)),
                        _c("span", [_vm._v(_vm._s(item.skuCode))])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order_item_detail_border" }, [
                        _c("div", { staticClass: "order_item_detail" }, [
                          _c(
                            "div",
                            { staticClass: "order_item_detail_title" },
                            [_vm._v("Brand")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "order_item_detail_content" },
                            [_vm._v(_vm._s(item.brandName))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "order_item_detail" }, [
                          _c(
                            "div",
                            { staticClass: "order_item_detail_title" },
                            [_vm._v("Items")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "order_item_detail_content" },
                            [
                              _vm._v(
                                _vm._s(
                                  item.serviceOrderWaitNum
                                    ? item.serviceOrderWaitNum
                                    : item.num
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "order_item_detail" }, [
                          _c(
                            "div",
                            { staticClass: "order_item_detail_title" },
                            [_vm._v("Wholesale Price")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "order_item_detail_content" },
                            [_vm._v(_vm._s(item.unitPrice))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "order_item_detail" }, [
                          _c(
                            "div",
                            { staticClass: "order_item_detail_title" },
                            [_vm._v("Total")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "order_item_detail_content" },
                            [_vm._v(_vm._s(item.commodityAmount))]
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("el-divider")
                ],
                1
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shipping-invoice-tips" }, [
          _vm._v(
            "There are other items from your order not included in this shipment."
          )
        ]),
        _vm._v(" "),
        _c("div", {
          staticStyle: {
            height: "2px",
            "background-color": "#5E5E5E",
            display: "block",
            width: "100%",
            "margin-top": "30px"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "shipping-invoice-footer" }, [
          _c("div", { staticClass: "shipping-invoice-footer-title" }, [
            _vm._v("Thank you for shopping with us!")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "shipping-invoice-footer-brand" }, [
            _vm._v("Suppliers: "),
            _c("span", [_vm._v(_vm._s(_vm.tsStoreOrderInfo.brandName))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "shipping-invoice-footer-website" }, [
            _vm._v("www.shopvidi.com")
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19871e0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19871e0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/shipping/shipping-invoice.vue
// module id = Vjns
// module chunks = 2